import React from 'react';
import { motion } from 'framer-motion';
import {
  FaTruck, FaCar, FaKeyboard, FaBolt, FaUtensils,
  FaShieldAlt, FaBroom, FaTools,
} from 'react-icons/fa';
import SectionHeader from './_primitives/SectionHeader';

const ROLES = [
  { icon: <FaTruck />,     label: 'Delivery',   count: '1.8L+ jobs' },
  { icon: <FaCar />,       label: 'Driver',      count: '2.1L+ jobs' },
  { icon: <FaKeyboard />,  label: 'Data Entry',  count: '72K+ jobs'  },
  { icon: <FaBolt />,      label: 'Electrician', count: '52K+ jobs'  },
  { icon: <FaUtensils />,  label: 'Cook',        count: '38K+ jobs'  },
  { icon: <FaShieldAlt />, label: 'Security',    count: '98K+ jobs'  },
  { icon: <FaBroom />,     label: 'Cleaner',     count: '44K+ jobs'  },
  { icon: <FaTools />,     label: 'Mechanic',    count: '61K+ jobs'  },
];

export default function PopularRolesGrid({ onStartSearching }) {
  return (
    <section className="py-14 md:py-24 px-4 sm:px-6 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          eyebrow="Popular roles"
          title="Explore jobs by role"
          subtitle="From skilled trades to tech — see what's hiring right now."
        />
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {ROLES.map((role, i) => (
            <motion.button
              key={role.label}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              onClick={onStartSearching}
              className="group flex flex-col items-center gap-3 p-4 sm:p-6
                         rounded-2xl border border-gray-100 bg-white
                         hover:border-brand-purple hover:shadow-purple
                         hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-ink-100 flex items-center justify-center
                              text-xl text-ink-700 group-hover:bg-brand-purple
                              group-hover:text-white transition-all">
                {role.icon}
              </div>
              <div>
                <div className="font-display font-bold text-ink-900">{role.label}</div>
                <div className="text-xs text-ink-300 mt-0.5">{role.count}</div>
              </div>
              <span className="text-xs font-bold text-brand-purple opacity-0
                               group-hover:opacity-100 transition-opacity">
                See All →
              </span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
